<template>

    <Toast/>

    <MenuFinancialCompact v-if="userStore.user?.roles?.includes('ROLE_ISORISE')" />
    <MenuHealthCompact v-else />

    <div class="px-6 surface-overlay relative">

        <div v-show="activeTab === 1" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Financials</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callOverallFinancialTransactions" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Financial Transactions</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callSupportingDocuments" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Supporting Documents</span>
                                </a>
                            </li>

                            <li>
                                <a @click="callLoadDefaultAccounts" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Load Default Accounts</span>
                                </a>
                            </li>

                        </ul>
                    </div>

                    <div style="height: 0.5rem;"></div>

                    <div class="col-12 md:col-12">
                        <div class="card p-fluid">
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <Calendar id="dob" v-model="parsedStartDate" dateFormat="yy-mm-dd"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Calendar id="dob" v-model="parsedEndDate" dateFormat="yy-mm-dd"/>
                                    </div>
                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-12 p-12">
                                        <Button type="button" icon="pi pi-filter-slash" label="Refresh"
                                                class="p-button-outlined p-ml-2"
                                                @click="refreshFinancialManagementInfo()"/>
                                    </div>
                                </div>
                            </div>

                            <div class="flex justify-content-between border-bottom-0 surface-border p-2">
                            </div>

                            <div class="flex justify-content-between border-bottom-0 surface-border p-2">
                                <span class="font-semibold text-color-primary text-xl">Income</span>
                                <span class="text-color-primary text-xl font-bold">{{
                                        this.companyCurrency
                                    }} {{ formatAmount(this.financialSummary.invoiceSummary) }}</span>
                            </div>

                            <div class="flex justify-content-between border-bottom-0 surface-border p-2">
                                <span class="font-semibold text-color-primary text-xl">Expenses</span>
                                <span class="text-color-primary text-xl font-bold">{{
                                        this.companyCurrency
                                    }} {{ formatAmount(this.financialSummary.expenses) }}</span>
                            </div>

                            <div class="flex justify-content-between border-bottom-1 surface-border p-2">
                                <span v-show="this.financialSummary.profit >= 0"
                                      class="font-semibold text-green-500 text-xl">Profit</span>
                                <span v-show="this.financialSummary.profit < 0"
                                      class="font-semibold text-red-500 text-xl">Profit</span>
                                <span v-show="this.financialSummary.profit >= 0"
                                      class="text-green-500 text-xl font-bold">{{
                                        this.companyCurrency
                                    }} {{ formatAmount(this.financialSummary.profit) }}</span>
                                <span v-show="this.financialSummary.profit < 0" class="text-red-500 text-xl font-bold">{{
                                        this.companyCurrency
                                    }} {{ formatAmount(this.financialSummary.profit) }}</span>
                            </div>

                            <div class="flex justify-content-between border-bottom-0 surface-border p-2">
                            </div>
                            <div class="flex justify-content-between border-bottom-0 surface-border p-2">
                            </div>

                            <div class="flex justify-content-between border-bottom-0 surface-border p-2">
                                <span class="font-semibold text-color-primary text-xl">Payments Received</span>
                                <span class="text-color-primary text-xl font-bold">{{
                                        this.companyCurrency
                                    }} {{ formatAmount(this.financialSummary.paymentSummary) }}</span>
                            </div>

                            <div class="flex justify-content-between border-bottom-0 surface-border p-2">
                            </div>
                            <div class="flex justify-content-between border-bottom-0 surface-border p-2">
                            </div>

                            <div class="flex justify-content-between border-bottom-1 surface-border p-3">
                                <span class="font-semibold text-color-primary text-l">Summary of Expenses</span>
                                <span class="text-color-primary text-l font-bold">{{
                                        this.companyCurrency
                                    }} {{ formatAmount(this.financialSummary.expenses) }}</span>
                            </div>

                            <div class="p-3">
                                <div v-for="item in financialAccountSummary" :key="item.financialAccountCode"
                                     class="flex align-items-center justify-content-between py-2">
                                    <div class="flex gap-3 text-l align-items-center">
                                        <!--                                        <i :class="getIcon(item.type)" class="text-color-secondary"></i>-->
                                        <i class="pi pi-money-bill text-color-secondary"></i>
                                        <span class="text-color-secondary">{{ item.financialAccountName }}</span>
                                    </div>
                                    <div class="flex align-items-center gap-2">
                                        <span class="font-semibold text-base">{{ companyCurrency }} {{ formatAmount(item.amount) }}</span>
                                        <a @click="callViewFinancialTransactions(item)" class="text-color-secondary">
                                            <i class="pi pi-angle-double-right"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 2" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Financial Transactions</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Home</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callNewActualFinancialTransaction" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>New Transaction</span>
                                </a>
                            </li>
                            <li>
                                <a @click="callRecodeFinancialTransaction" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Recode Transactions</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable :value="financialTransactions" :paginator="true"
                               class="p-datatable-gridlines"
                               :rows="100" dataKey="id" :rowsPerPageOptions="[10,20,50,100]" :rowHover="true"
                               :striped-rows="true" :reorderableColumns="true"
                               v-model:filters="filters" filterDisplay="menu" :loading="loading"
                               :filters="filters" responsiveLayout="scroll"
                               :globalFilterFields="['financialAccountCode', 'financialAccountName', 'processed', 'description']">

                        <template #header>
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <Calendar id="dob" v-model="parsedStartDate" dateFormat="yy-mm-dd"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Calendar id="dob" v-model="parsedEndDate" dateFormat="yy-mm-dd"/>
                                    </div>
                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-12 p-12">
                                        <Button type="button" icon="pi pi-filter-slash" label="Refresh"
                                                class="p-button-outlined p-ml-2"
                                                @click="refreshFinancialTransctionInfo()"/>
                                    </div>
                                </div>
                            </div>

                            <div class="flex justify-content-between border-bottom-0 surface-border p-2">
                            </div>

                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedColumns" :options="columnsFullList"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleColumns"
                                                     display="chip" placeholder="Select Columns"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <MultiSelect :modelValue="selectedStandardFilter" :options="standardFilters"
                                                     optionLabel="header"
                                                     @update:modelValue="onToggleStandardFilters"
                                                     display="chip" placeholder="Select Standard Filter"/>
                                    </div>
                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-filter-slash" label="Clear Search"
                                                class="p-button-outlined p-ml-2" @click="clearFilter()"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Button type="button" icon="pi pi-replay" label="Restore to Original View"
                                                class="p-button-outlined" @click="restoreToOriginal()"/>
                                    </div>
                                </div>

                                <div class="p-col-12 p-md-2">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"/>
                                        <InputText v-model="filters['global'].value"
                                                   placeholder="Keyword Search on Code, Name, Description or Processed Date"
                                                   style="width: 100%"/>
                                    </span>
                                </div>
                            </div>
                        </template>

                        <template #empty>
                            No financial transactions found.
                        </template>

                        <template #loading>
                            Loading financial transactions. Please wait.
                        </template>

                        <Column
                            field="selectAnOption"
                            header=""
                            :headerStyle="{ width: '2rem' }"
                            :bodyStyle="{ width: '2rem', padding: '0.25rem' }">
                            <template #body="{ data, index }">
                                <Button icon="pi pi-ellipsis-v" class="p-button-sm p-button-text p-button-rounded m-0"
                                        @click="$refs['financialMenu' + index].toggle($event)"/>
                                <Menu
                                    :ref="'financialMenu' + index"
                                    :model="getFilteredItems(data)"
                                    :popup="true"/>
                            </template>
                        </Column>

                        <Column field="processed" header="Processed" :sortable="true"/>

                        <template v-for="col in selectedColumns" :key="col.field">

                            <Column v-if="col.field === 'financialAccountType'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Type</span>
                                    <span v-if="data.financialAccountType === 'FA'"
                                          :class="'type-badge status-' + data.financialAccountType">Fixed Assets</span>
                                    <span v-if="data.financialAccountType === 'CA'"
                                          :class="'type-badge status-' + data.financialAccountType">Current Assets</span>
                                    <span v-if="data.financialAccountType === 'I'"
                                          :class="'type-badge status-' + data.financialAccountType">Income</span>
                                    <span v-if="data.financialAccountType === 'E'"
                                          :class="'type-badge status-' + data.financialAccountType">Expenses</span>
                                    <span v-if="data.financialAccountType === 'CL'"
                                          :class="'type-badge status-' + data.financialAccountType">Current Liabilities</span>
                                    <span v-if="data.financialAccountType === 'LL'"
                                          :class="'type-badge status-' + data.financialAccountType">Long-Term Liabilities</span>
                                    <span v-if="data.financialAccountType === 'OE'"
                                          :class="'type-badge status-' + data.financialAccountType">Owners Equity</span>
                                </template>
                            </Column>

                            <Column v-else-if="col.field === 'status'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Status</span>
                                    <span v-if="data.status === 'A'"
                                          :class="'status-badge status-' + data.status">Active</span>
                                    <span v-else
                                          :class="'status-badge status-I'">Inactive</span>
                                </template>
                            </Column>

                            <Column v-else-if="col.field === 'debit'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Debit</span>
                                    <span>{{ formatAmount(data.debit) }}</span>
                                </template>
                            </Column>

                            <Column v-else-if="col.field === 'credit'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Credit</span>
                                    <span>{{ formatAmount(data.credit) }}</span>
                                </template>
                            </Column>

                            <Column v-else :field="col.field" :header="col.header" :sortable="col.sortable"/>

                        </template>

                    </DataTable>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 3" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Import Financial Transactions Document</h3>

                    <div class="field">
                        <label for="inputFormat">Input Format</label>
                        <Dropdown v-model="inputFormat" :options="inputFormats"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>
                    </div>

                    <div class="p-field">
                        <input type="file" @change="handleFileUpload" accept=".csv, application/pdf"/>
                    </div>

                    <br/>

                    <div class="p-field">
                        <Button label="Review" :loading="submitted" class="mr-2 mb-2" :disabled="!file" @click="submitFile"></Button>
                    </div>

                    <br/>
                    <div class="p-field">
                        <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetFinancialTransactions"></Button>
                    </div>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 4" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Review Financial Transactions To Import</h3>

                    <DataTable :value="financialTransactions" :paginator="true"
                               class="p-datatable-gridlines"
                               :rows="200" dataKey="id" :rowsPerPageOptions="[10,20,50,100]" :rowHover="true"
                               :striped-rows="true" :reorderableColumns="true"
                               :loading="loading"
                               responsiveLayout="scroll">

                        <template #empty>
                            No financial transactions found.
                        </template>

                        <template #loading>
                            Loading financial transactions. Please wait.
                        </template>

                        <Column field="selectAnOption" style="width: 10%">
                            <template #body="{ data }">
                                <Button v-tooltip="'Update'" icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success m-1"
                                        :loading="submitted" @click="callUpdateFinancialTransaction(data)"/>

                                <Button v-tooltip="'Delete'" icon="pi pi-trash"
                                        class="p-button-rounded p-button-danger m-1"
                                        :loading="submitted" @click="callDeleteFinancialTransaction(data)"/>
                            </template>
                        </Column>

                        <Column field="id" header="ID" :sortable="true"/>
                        <Column field="processed" header="Processed" :sortable="true"/>
                        <Column field="financialAccountCode" header="Financial Account Code" :sortable="true"/>
                        <Column field="description" header="Description" :sortable="true"/>

                        <Column field="amount" header="Amount" :sortable="true">
                            <template #body="{data}">
                                <span class="p-column-title">Amount</span>
                                {{ formatAmount(data.amount) }}
                            </template>
                        </Column>

                    </DataTable>

                    <Button label="Upload" class="mr-2 mb-2" :loading="submitted" @click="importFinancialTransactions"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetFinancialTransactions"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 5" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Imported Financial Transaction</h3>

                    <div class="field">
                        <label for="processed">Processed Date</label>
                        <Calendar id="processed" v-model="parsedProcessed" required="true"
                                  :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <div class="field">
                        <label for="financialAccountCode">Financial Account Code</label>
                        <InputText id="financialAccountCode" v-model.trim="currentTransaction.financialAccountCode" required="true"/>
                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model="currentTransaction.description" required="true"/>
                    </div>

                    <div class="field">
                        <label for="amount">Amount</label>
                        <InputText id="amount" v-model.trim="currentTransaction.amount" required="true"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateFinancialTransaction"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetImportedFinancialTransactions"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 6" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Imported Financial Transaction</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Imported Financial Transaction?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteFinancialTransaction"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetImportedFinancialTransactions"></Button>

                </div>
            </div>
        </div>


        <div v-show="activeTab === 7" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Update Financial Transaction</h3>

                    <div class="field">
                        <label for="processed">Processed Date</label>
                        <Calendar id="processed" v-model="parsedActualProcessed" required="true"
                                  :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <div class="field">
                        <label for="financialAccountCode">Financial Account Code</label>
                        <Dropdown v-model="financialTransaction.financialAccountCode" :options="financialAccounts"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>

                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model="financialTransaction.description" required="true"/>
                    </div>

                    <div class="field">
                        <label for="debit">Debit</label>
                        <InputText id="debit" v-model="financialTransaction.debit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="credit">Credit</label>
                        <InputText id="credit" v-model="financialTransaction.credit" required="true"/>
                    </div>

                    <Button label="Update" class="mr-2 mb-2" :loading="submitted" @click="updateActualFinancialTransaction"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetFinancialTransactions"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 8" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Financial Transaction</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Financial Transaction?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteActualFinancialTransaction"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetFinancialTransactions"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 9" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>New Financial Transaction</h3>

                    <div class="field">
                        <label for="processed">Processed Date</label>
                        <Calendar id="processed" v-model="financialTransaction.processed" required="true"
                                  :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <div class="field">
                        <label for="financialAccountCode">Financial Account Code</label>
                        <Dropdown v-model="financialTransaction.financialAccountCode" :options="financialAccounts"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>

                    </div>

                    <div class="field">
                        <label for="description">Description</label>
                        <InputText id="description" v-model="financialTransaction.description" required="true"/>
                    </div>

                    <div class="field">
                        <label for="debit">Debit</label>
                        <InputText id="debit" v-model="financialTransaction.debit" required="true"/>
                    </div>

                    <div class="field">
                        <label for="credit">Credit</label>
                        <InputText id="credit" v-model="financialTransaction.credit" required="true"/>
                    </div>

                    <Button label="Create" class="mr-2 mb-2" :loading="submitted" @click="createActualFinancialTransaction"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetFinancialTransactions"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 10" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Recode Financial Transactions</h3>

                    <div class="field">
                        <Calendar id="startDate" v-model="recodeFinancialTransaction.startDate" required="true"
                                  :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <div class="field">
                        <label for="endDate">End Date</label>
                        <Calendar id="endDate" v-model="recodeFinancialTransaction.endDate" required="true"
                                  :showTime="false"
                                  :showSeconds="false" :showIcon="true" dateFormat="yy-mm-dd"/>
                    </div>

                    <div class="field">
                        <label for="financialAccountCode">Financial Account Code</label>
                        <!--                        <InputText id="financialAccountCode" v-model.trim="financialTransaction.financialAccountCode" required="true"/>-->

                        <Dropdown v-model="recodeFinancialTransaction.financialAccountCode" :options="financialAccounts"
                                  optionLabel="name" optionValue="code"
                                  placeholder="Select an Option"/>

                    </div>

                    <div class="field">
                        <label for="description">Partial Description To Search For</label>
                        <InputText id="description" v-model="recodeFinancialTransaction.description" required="true"/>
                    </div>

                    <Button label="Recode" class="mr-2 mb-2" :loading="submitted" @click="recodeFinancialTransactions"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetFinancialTransactions"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 11" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Load Default Financial Accounts</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Load the Default Values?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response" />
                    </div>

                    <Button label="Save" :loading="submitted" class="mr-2 mb-2" @click="loadDefaultAccounts"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 12" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Add Document to Financial Transaction</h3>

                    <div class="p-field">
                        <input
                            type="file"
                            ref="fileInput"
                            @change="handleClientFileUpload"
                            accept="application/pdf,image/png,image/jpeg"/>
                    </div>

                    <br/>

                    <div class="p-field">
                        <Button label="Upload" class="mr-2 mb-2" :disabled="!fileDocument"
                                @click="uploadClientFile"></Button>
                    </div>

                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callResetFinancialTransactions"></Button>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 13" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Manage Supporting Documents for Financial Transactions</h3>

                    <div class="grid">
                        <ul class="list-none p-0 m-0 flex lg:align-items-center flex-column lg:flex-row select-none">
                            <li>
                                <a @click="callReset" v-ripple
                                   class="flex p-3 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150 p-ripple">
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Back to Home</span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <DataTable :value="financialTransactionDocuments" :paginator="true"
                               class="p-datatable-gridlines"
                               :rows="100" dataKey="id" :rowsPerPageOptions="[10,20,50,100]" :rowHover="true"
                               :striped-rows="true" :reorderableColumns="true"
                               v-model:filters="filters" filterDisplay="menu" :loading="loading"
                               :filters="filters" responsiveLayout="scroll"
                               :globalFilterFields="['financialAccountCode', 'financialAccountName', 'processed', 'description']">

                        <template #header>
                            <div class="p-grid">
                                <div class="grid">
                                    <div class="col-12 lg:col-6 p-2">
                                        <Calendar id="dob" v-model="parsedStartDate" dateFormat="yy-mm-dd"/>
                                    </div>
                                    <div class="col-12 lg:col-6 p-2">
                                        <Calendar id="dob" v-model="parsedEndDate" dateFormat="yy-mm-dd"/>
                                    </div>
                                </div>

                                <div class="grid">
                                    <div class="col-12 lg:col-12 p-12">
                                        <Button type="button" icon="pi pi-filter-slash" label="Refresh"
                                                class="p-button-outlined p-ml-2"
                                                @click="refreshFinancialTransctionStorageInfo()"/>
                                    </div>
                                </div>
                            </div>

                        </template>

                        <template #empty>
                            No financial transaction documents found.
                        </template>

                        <template #loading>
                            Loading financial transaction documents. Please wait.
                        </template>

                        <Column
                            field="selectAnOption"
                            header=""
                            :headerStyle="{ width: '2rem' }"
                            :bodyStyle="{ width: '2rem', padding: '0.25rem' }">
                            <template #body="{ data, index }">
                                <Button icon="pi pi-ellipsis-v" class="p-button-sm p-button-text p-button-rounded m-0"
                                        @click="$refs['storageMenu' + index].toggle($event)"/>
                                <Menu
                                    :ref="'storageMenu' + index"
                                    :model="getFilteredItemsForStorage(data)"
                                    :popup="true"/>
                            </template>
                        </Column>

                        <template v-for="col in selectedColumns" :key="col.field">

                            <Column v-if="col.field === 'processed'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Processed</span>
                                    <span>{{ formatDate(data.processed) }}</span>
                                </template>
                            </Column>

                            <Column v-else-if="col.field === 'financialAccountType'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Type</span>
                                    <span v-if="data.financialAccountType === 'FA'"
                                          :class="'type-badge status-' + data.financialAccountType">Fixed Assets</span>
                                    <span v-if="data.financialAccountType === 'CA'"
                                          :class="'type-badge status-' + data.financialAccountType">Current Assets</span>
                                    <span v-if="data.financialAccountType === 'I'"
                                          :class="'type-badge status-' + data.financialAccountType">Income</span>
                                    <span v-if="data.financialAccountType === 'E'"
                                          :class="'type-badge status-' + data.financialAccountType">Expenses</span>
                                    <span v-if="data.financialAccountType === 'CL'"
                                          :class="'type-badge status-' + data.financialAccountType">Current Liabilities</span>
                                    <span v-if="data.financialAccountType === 'LL'"
                                          :class="'type-badge status-' + data.financialAccountType">Long-Term Liabilities</span>
                                    <span v-if="data.financialAccountType === 'OE'"
                                          :class="'type-badge status-' + data.financialAccountType">Owners Equity</span>
                                </template>
                            </Column>

                            <Column v-else-if="col.field === 'status'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Status</span>
                                    <span v-if="data.status === 'A'"
                                          :class="'status-badge status-' + data.status">Active</span>
                                    <span v-else
                                          :class="'status-badge status-I'">Inactive</span>
                                </template>
                            </Column>

                            <Column v-else-if="col.field === 'debit'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Debit</span>
                                    <span>{{ formatAmount(data.debit) }}</span>
                                </template>
                            </Column>

                            <Column v-else-if="col.field === 'credit'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Credit</span>
                                    <span>{{ formatAmount(data.credit) }}</span>
                                </template>
                            </Column>

                            <Column v-else-if="col.field === 'storageFileName'" :field="col.field" :header="col.header"
                                    :sortable="col.sortable">
                                <template #body="{data}">
                                    <span class="p-column-title">Storage ID</span>
                                    <span>{{ getCleanFilename(data.storageFileName) }}</span>
                                </template>
                            </Column>

                            <Column v-else :field="col.field" :header="col.header" :sortable="col.sortable"/>

                        </template>

                    </DataTable>

                </div>
            </div>
        </div>

        <div v-show="activeTab === 14" class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">

                    <h3>Delete Supporting Document for Financial Transaction</h3>

                    <div class="field">
                        <label for="confirmationResponse">Do You Wish to Delete this Document?</label>
                        <Dropdown v-model="confirmationResponse" :options="confirmationTypes" optionLabel="name"
                                  optionValue="code" placeholder="Select a Response"/>
                    </div>

                    <Button label="Delete" class="mr-2 mb-2" :loading="submitted" @click="deleteStorageRecord"></Button>
                    <Button label="Cancel" class="mr-2 mb-2" :loading="submitted" @click="callReset"></Button>

                </div>
            </div>
        </div>


    </div>

    <IsoEvolveFooter/>

</template>

<script>
import IsoEvolveFooter from "@/components/heading/authentication/IsoEvolveFooter.vue";
import MenuHealthCompact from "@/components/menu/health/MenuHealthCompact.vue";
import {useUserStore} from "@/stores/UserStore";
import UserService from "@/service/UserService";
import {FilterMatchMode, FilterOperator} from "primevue/api";
import CompanyService from "@/service/CompanyService";
import InvoiceService from "@/service/InvoiceService";
import numeral from "numeral";
import BillingPlanService from "@/service/BillingPlanService";
import moment from "moment/moment";
import ClaimService from "@/service/ClaimService";
import DashboardService from "@/service/DashboardService";
import FinancialTransactionService from "@/service/FinancialTransactionService";
import axios from "axios";
import FinancialAccountService from "@/service/FinancialAccountService";
import MenuFinancialCompact from "@/components/menu/famodule/MenuFinancialCompact.vue";
import StorageService from "@/service/StorageService";

export default {
    components: {
        MenuFinancialCompact,
        IsoEvolveFooter, MenuHealthCompact
    },
    props: {
        inputAppointmentId: {
            type: String,
            required: false
        },
        inputInvoiceId: {
            type: String,
            required: false
        }
    },
    computed: {
        parsedStartDate: {
            get() {
                return new Date(this.summary.start);
            },
            set(value) {
                this.summary.start = value instanceof Date ? value.toISOString() : '';
            }
        },
        parsedEndDate: {
            get() {
                return new Date(this.summary.end);
            },
            set(value) {
                this.summary.end = value instanceof Date ? value.toISOString() : '';
            }
        },
        parsedProcessed: {
            get() {
                return this.currentTransaction.processed ? new Date(this.currentTransaction.processed) : null;
            },
            set(value) {
                if (value) {
                    this.currentTransaction.processed = value.toISOString().split('T')[0];
                } else {
                    this.currentTransaction.processed = '';
                }
            }
        },
        parsedActualProcessed: {
            get() {
                return this.financialTransaction.processed ? new Date(this.financialTransaction.processed) : null;
            },
            set(value) {
                if (value) {
                    this.financialTransaction.processed = value.toISOString().split('T')[0];
                } else {
                    this.financialTransaction.processed = '';
                }
            }
        }

    },
    setup() {
        const userStore = useUserStore()

        return {
            userStore
        }
    },

    created() {
        this.initFilters();
    },
    async mounted() {
        try {
            await UserService.getUserPing();
        } catch (e) {
            this.userStore.clearUser();
            this.$router.push("login");
            return;
        }

        if (!this.userStore.user.id) {
            this.userStore.clearUser();
            this.$router.push('login');
            return;
        }

        await this.loadCompanyContext();

    },
    data() {

        return {
            fileDocument: null,
            profile: {},
            submitted: false,
            summary: {},
            companyCurrency: "R",
            financialSummary: {},
            financialAccountSummary: [],
            selectedFile: null,
            financialTransactions: [],
            originalFinancialTransactions: null,
            financialTransactionDocuments: [],
            originalFinancialTransactionDocuments: null,
            financialTransaction: {},
            financialTransactionDocument: {},
            recodeFinancialTransaction: {},
            financialAccounts: null,
            invoices: null,
            originalInvoices: null,
            invoice: {},
            userConfiguration: {},
            companyConfiguration: {},
            filters: null,
            loading: true,
            loadingResponse: false,
            activeTab: 1,
            confirmationResponse: 'N',
            selectedColumns: null,
            columnsDefault: null,
            columnsFullList: null,
            selectedStandardFilter: null,
            standardFilters: null,
            healthInsuranceSubmissionMethodResponse: 'E',
            invoiceComponents: null,
            invoiceComponent: {},
            newInvoice: {},
            newPayment: {},
            inputFormat: null,
            billingPlans: null,
            billingPlan: {},
            products: null,
            product: {},
            currentTransaction: {},
            filteredBillingPlans: [],
            filteredProducts: [],
            filteredDiagnosticCodes: [],
            statusTypes: [
                {name: 'Paid', code: 'P'},
                {name: 'Unpaid', code: 'I'},
                {name: 'Submitted', code: 'S'},
                {name: 'Unpaids Process', code: 'U'},
                {name: 'Archived', code: 'C'}
            ],
            statusTypesLimited: [
                {name: 'Paid', code: 'P'},
                {name: 'Unpaid', code: 'I'},
                {name: 'Submitted', code: 'S'},
                {name: 'Member Liable', code: 'M'}
            ],
            confirmationTypes: [
                {name: 'Yes', code: 'Y'},
                {name: 'No', code: 'N'}
            ],
            healthInsuranceSubmissionMethod: [
                {name: 'Email', code: 'E'},
                {name: 'Electronic Data Interchange (EDI)', code: 'D'}
            ],
            paymentTypes: [
                {name: 'Credit Card', code: 'C'},
                {name: 'Bank Transfer', code: 'B'},
                {name: 'Health Insurance', code: 'H'},
                {name: 'Cryptocurrency', code: 'R'},
                {name: 'Cash', code: 'A'},
                {name: 'Other', code: 'O'},
                {name: 'Write-Off', code: 'W'}
            ],
            file: null,
            url: "/financialtransaction/import/bank/absa/1",
            fileAccept: '.csv, application/pdf',
            inputFormats: [
                {name: 'Generic Format (CSV)', code: '001'},
                {name: 'ABSA Bank Format (PDF)', code: '002'}
            ],

        }
    },
    watch: {
        'userStore.activeCompanyId': {
            immediate: false,
            async handler(newCompanyId, oldCompanyId) {
                if (!newCompanyId || newCompanyId === oldCompanyId) {
                    return;
                }

                await this.loadCompanyContext();
            }
        }
    },
    methods: {
        async loadCompanyContext() {
            try {
                const userData = await UserService.getUser(this.userStore.user.id);
                this.profile = userData.data;
            } catch (e) {
                this.userStore.clearUser();
                this.$router.push('login');
                return;
            }

            this.profile.companyId = this.userStore.activeCompanyId;

            const [userConfigurationData, companyConfigurationData] = await Promise.all([
                UserService.getUserConfig(this.userStore.user.id),
                CompanyService.getCompanyConfiguration(this.profile.companyId)
            ]);

            this.userConfiguration = userConfigurationData.data;
            this.companyConfiguration = companyConfigurationData.data;

            this.loading = false;

            this.columnsDefault = [
                {field: 'financialAccountType', header: 'Type', sortable: true},
                {field: 'financialAccountCode', header: 'Code', sortable: true},
                {field: 'financialAccountName', header: 'Name', sortable: true},
                {field: 'status', header: 'Status', sortable: true},
                {field: 'description', header: 'Description', sortable: true},
                {field: 'debit', header: 'Debit', sortable: true},
                {field: 'credit', header: 'Credit', sortable: true}
            ];

            this.columnsFullList = [
                {field: 'financialAccountType', header: 'Type', sortable: true},
                {field: 'financialAccountCode', header: 'Code', sortable: true},
                {field: 'financialAccountName', header: 'Name', sortable: true},
                {field: 'status', header: 'Status', sortable: true},
                {field: 'description', header: 'Description', sortable: true},
                {field: 'debit', header: 'Debit', sortable: true},
                {field: 'credit', header: 'Credit', sortable: true}
            ];

            this.selectedColumns = this.columnsDefault;

            this.standardFilters = [
                {field: 'debit', header: 'Debit'},
                {field: 'credit', header: 'Credit'}
            ];

            if (this.companyConfiguration.region === "ZA") {
                this.companyCurrency = "R";
            } else if (this.companyConfiguration.region === "UK") {
                this.companyCurrency = "£";
            } else if (this.companyConfiguration.region === "CA") {
                this.companyCurrency = "CAD";
            } else if (this.companyConfiguration.region === "IN") {
                this.companyCurrency = "INR";
            } else {
                this.companyCurrency = "$";
            }

            this.summary.start = moment().startOf('year').format('YYYY-MM-DD');
            this.summary.end = moment().format('YYYY-MM-DD');

            const startDateInput = new Date((this.summary.start));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

            const endDateInput = new Date((this.summary.end));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

            const [financialSummaryData, financialAccountSummaryData] = await Promise.all([
                DashboardService.getFinancialSummaryForCompany(this.profile.companyId, this.summary.start, this.summary.end),
                FinancialTransactionService.getFinancialAccountSummary(this.profile.companyId, startDate, endDate)

            ]);

            this.financialSummary = financialSummaryData.data;
            this.financialAccountSummary = financialAccountSummaryData.data;

            const totalExpenses = this.financialAccountSummary
                .filter(account => account.financialAccountType === 'E')
                .reduce((sum, account) => sum + account.amount, 0);

            this.financialSummary.expenses = totalExpenses;
            this.financialSummary.profit = this.financialSummary.invoiceSummary - this.financialSummary.expenses;

            this.financialAccountSummary = this.financialAccountSummary.filter(item => item.financialAccountType === 'E');
        },
        callReset() {
            this.activeTab = 1;
        },
        callResetFinancialTransactions() {
            this.refreshFinancialTransctionInfo();
            this.activeTab = 2;
        },
        async callResetImportedFinancialTransactions() {
            this.refreshFinancialTransctionInfo();
            this.activeTab = 4;
        },
        getCleanFilename(name) {

            const cleanFilename =
                name.includes("~")
                    ? name.substring(name.lastIndexOf("~") + 1)
                    : name;

            return cleanFilename.substring(
                0,
                cleanFilename.lastIndexOf(".")
            ) || cleanFilename;
        },
        formatDate(dateString) {

            if (
                !dateString ||
                typeof dateString !== 'string'
            ) {
                return '';
            }

            return dateString.replace(/\//g, '-');
        },
        handleFileUpload(event) {
            this.file = event.target.files[0];
        },
        async submitFile() {
            this.submitted = true;

            if (!this.file) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No file selected.',
                    life: 3000
                });
            }

            const formData = new FormData();
            formData.append('file', this.file);

            var url = "/api/financialtransaction/import/generic/" + this.profile.companyId;

            if (this.inputFormat == "002") {
                url = "/api/financialtransaction/import/bank/absa/" + this.profile.companyId;
            }

            try {
                const response = await axios.post(url, formData, {
                    headers: {
                        'Authorization': `Bearer ${this.userStore.user.accessToken}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Loaded financial transactions',
                    life: 3000
                });

                this.financialTransactions = response.data;
                this.activeTab = 4;
                // Handle the response as needed
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'File upload NOT successful',
                    life: 3000
                });

                // Handle the error as needed
            }

            this.file = null;
            this.submitted = false;
        },
        async importFinancialTransactions() {
            this.submitted = true;

            try {
                await FinancialTransactionService.createFinancialTransactionBatch(this.profile.companyId, this.financialTransactions);

                this.refreshFinancialTransctionInfo();

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Imported financial transaction',
                    life: 3000
                });
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to import financial transactions. Please try again.',
                    life: 3000
                });
            }

            this.activeTab = 2;
            this.submitted = false;
        },
        async refreshFinancialManagementInfo() {
            this.activeTab = 1;

            const startDateInput = new Date((this.summary.start));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

            const endDateInput = new Date((this.summary.end));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

            const [financialSummaryData, financialAccountSummaryData] = await Promise.all([
                DashboardService.getFinancialSummaryForCompany(this.profile.companyId, this.summary.start, this.summary.end),
                FinancialTransactionService.getFinancialAccountSummary(this.profile.companyId, startDate, endDate)

            ]);

            this.financialSummary = financialSummaryData.data;
            this.financialAccountSummary = financialAccountSummaryData.data;

            const totalExpenses = this.financialAccountSummary
                .filter(account => account.financialAccountType === 'E')
                .reduce((sum, account) => sum + account.amount, 0);

            this.financialSummary.expenses = totalExpenses;
            this.financialSummary.profit = this.financialSummary.invoiceSummary - this.financialSummary.expenses;

            this.financialAccountSummary = this.financialAccountSummary.filter(item => item.financialAccountType === 'E');
        },
        async refreshFinancialTransctionInfo() {
            this.activeTab = 2;

            const startDateInput = new Date((this.summary.start));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

            const endDateInput = new Date((this.summary.end));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

            const [responseDataTransactions] = await Promise.all([
                FinancialTransactionService.getFinancialTransactionsByCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.financialTransactions = responseDataTransactions.data;
            this.originalFinancialTransactions = this.financialTransactions;

            const [responseDataAccounts] = await Promise.all([
                FinancialAccountService.getCompanyFinancialAccounts(this.profile.companyId)
            ]);

            this.financialAccounts = responseDataAccounts.data;
        },
        async refreshFinancialTransctionStorageInfo() {
            this.activeTab = 13;

            const startDateInput = new Date((this.summary.start));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

            const endDateInput = new Date((this.summary.end));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

            const [responseData] = await Promise.all([
                FinancialTransactionService.getFinancialTransactionDocumentsByCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.financialTransactionDocuments = responseData.data;

            this.originalFinancialTransactionDocuments = this.financialTransactionDocuments;
        },
        callNewActualFinancialTransaction() {
            this.financialTransaction = {};
            this.activeTab = 9;
        },
        async callRecodeFinancialTransaction() {
            const [responseData] = await Promise.all([
                FinancialAccountService.getCompanyFinancialAccounts(this.profile.companyId)
            ]);

            this.financialAccounts = responseData.data;

            this.recodeFinancialTransaction = {
                startDate: moment().startOf('hour').toDate(),
                endDate: moment().startOf('hour').toDate(),
                financialAccountCode: this.financialAccounts[0].code,
            };

            this.activeTab = 10;
        },
        callUpdateActualFinancialTransaction(transaction) {
            this.financialTransaction = { ...transaction };
            this.activeTab = 7;
        },
        callDeleteActualFinancialTransaction(transaction) {
            this.financialTransaction = { ...transaction };
            this.activeTab = 8;
        },
        callAddDocumentToFinancialTransaction(transaction) {
            this.financialTransaction = { ...transaction };
            this.activeTab = 12;
            this.selectedClientFileType = 'C';
        },
        async createActualFinancialTransaction() {
            this.submitted = true;

            try {
                if (
                    this.financialTransaction.debit === 0 ||
                    this.financialTransaction.debit === '0'
                ) {
                    this.financialTransaction.debit = null;
                }

                if (
                    this.financialTransaction.credit === 0 ||
                    this.financialTransaction.credit === '0'
                ) {
                    this.financialTransaction.credit = null;
                }

                await FinancialTransactionService.createFinancialTransaction(this.profile.companyId, this.financialTransaction);

                this.refreshFinancialTransctionInfo();

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Updated financial transaction',
                    life: 3000
                });
            } catch (error) {

                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update financial transaction. Please try again.',
                    life: 3000
                });
            }

            this.activeTab = 2;
            this.submitted = false;

        },
        async updateActualFinancialTransaction() {
            this.submitted = true;

            try {
                await FinancialTransactionService.updateFinancialTransaction(this.financialTransaction.id, this.financialTransaction);

                this.refreshFinancialTransctionInfo();

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Updated financial transaction',
                    life: 3000
                });
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to update financial transaction. Please try again.',
                    life: 3000
                });
            }

            this.activeTab = 2;
            this.submitted = false;

        },
        async deleteActualFinancialTransaction() {
            this.submitted = true;

            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.financialTransaction.id) {
                    try {
                        await FinancialTransactionService.deleteFinancialTransaction(this.financialTransaction.id);

                        this.refreshFinancialTransctionInfo();

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted financial transaction',
                            life: 3000
                        });
                    } catch (error) {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete financial transaction. Please try again.',
                            life: 3000
                        });
                    }

                }
            }

            this.submitted = false;
            this.activeTab = 2;
        },
        async recodeFinancialTransactions() {
            this.submitted = true;

            try {
                await FinancialTransactionService.recodeFinancialTransactions(this.profile.companyId, this.recodeFinancialTransaction);

                this.summary.start = moment().startOf('year').format('YYYY-MM-DD');
                this.summary.end = moment().format('YYYY-MM-DD');

                const startDateInput = new Date((this.summary.start));
                const yearStart = startDateInput.getFullYear();
                const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
                const dayStart = String(startDateInput.getDate()).padStart(2, '0');
                const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

                const endDateInput = new Date((this.summary.end));
                const yearEnd = endDateInput.getFullYear();
                const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
                const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
                const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

                const [financialSummaryData, financialAccountSummaryData] = await Promise.all([
                    DashboardService.getFinancialSummaryForCompany(this.profile.companyId, this.summary.start, this.summary.end),
                    FinancialTransactionService.getFinancialAccountSummary(this.profile.companyId, startDate, endDate)

                ]);

                this.financialSummary = financialSummaryData.data;
                this.financialAccountSummary = financialAccountSummaryData.data;

                const totalExpenses = this.financialAccountSummary
                    .filter(account => account.financialAccountType === 'E')
                    .reduce((sum, account) => sum + account.amount, 0);

                this.financialSummary.expenses = totalExpenses;
                this.financialSummary.profit = this.financialSummary.invoiceSummary - this.financialSummary.expenses;

                this.financialAccountSummary = this.financialAccountSummary.filter(item => item.financialAccountType === 'E');

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Recoded financial transactions',
                    life: 3000
                });
            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to recode financial transactions. Please try again.',
                    life: 3000
                });
            }

            this.activeTab = 2;
            this.submitted = false;

        },
        callUpdateFinancialTransaction(transaction) {
            this.currentTransaction = { ...transaction };
            this.activeTab = 5;
        },
        callDeleteFinancialTransaction(transaction) {
            this.currentTransaction = { ...transaction };
            this.activeTab = 6;
        },
        updateFinancialTransaction() {
            this.submitted = true;

            const index = this.financialTransactions.findIndex(ft => ft.id === this.currentTransaction.id);

            if (index !== -1) {
                this.financialTransactions[index] = { ...this.currentTransaction };
            }

            this.activeTab = 4;
            this.submitted = false;

        },
        deleteFinancialTransaction() {
            this.submitted = true;

            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {
                this.financialTransactions = this.financialTransactions.filter(ft => ft.id !== this.currentTransaction.id);
            }

            this.submitted = false;
            this.activeTab = 4;
        },
        convertDateIntoUtcTimezone(inputDate) {
            try {
                const moment = require("moment-timezone");

                let inputTimeZone = "Europe/London";

                if (this.companyConfiguration.region == "ZA") {
                    inputTimeZone = "Africa/Johannesburg";
                }

                const targetTimeZone = "Etc/UTC"; // Assuming the input date is in UTC

                const parsedDate = moment.tz(inputDate, "YYYY-MM-DD HH:mm:ss", inputTimeZone);

                const outputDate = parsedDate.clone().tz(targetTimeZone);

                return outputDate.format("YYYY-MM-DD HH:mm:ss");

            } catch (error) {
                return inputDate;
            }

        },
        convertDateIntoLocalTimezone(inputDate) {
            try {
                const moment = require("moment-timezone");
                const inputTimeZone = "Etc/UTC"; // Assuming the input date is in UTC

                let targetTimeZone = "Europe/London";

                if (this.companyConfiguration.region == "ZA") {
                    targetTimeZone = "Africa/Johannesburg";
                }

                const parsedDate = moment.tz(inputDate, "YYYY-MM-DD HH:mm:ss", inputTimeZone);

                const outputDate = parsedDate.clone().tz(targetTimeZone);

                return outputDate.format("YYYY-MM-DD HH:mm:ss");

            } catch (error) {
                return inputDate;
            }

        },
        initFilters() {
            this.filters = {
                'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
                'financialAccountCode': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'financialAccountName': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'processed': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                },
                'description': {
                    operator: FilterOperator.AND,
                    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
                }
            }
        },
        async restoreToOriginal() {
            const [invoiceData] = await Promise.all([
                InvoiceService.getAllCompanyInvoices(this.profile.companyId)
            ]);

            this.invoices = invoiceData.data;
            this.originalInvoices = invoiceData.data;

            window.location.href = "/#/commonFinancialManagement";
        },
        clearFilter() {
            this.initFilters();
        },
        onToggleColumns(value) {
            this.selectedColumns = this.columnsFullList.filter(col => value.includes(col));
        },
        onToggleStandardFilters(value) {

            if (value.length > 1) {
                this.selectedStandardFilter = [value[value.length - 1]];
            } else {
                this.selectedStandardFilter = value;
            }

            const isDebit = value.some(item => item.field === "debit");
            const isCredit = value.some(item => item.field === "credit");

            if (this.financialTransactions !== null) {

                if (isDebit) {
                    this.financialTransactions = this.originalFinancialTransactions.filter(financialTransaction => financialTransaction.debit > 0);
                } else if (isCredit) {
                    this.financialTransactions = this.originalFinancialTransactions.filter(financialTransaction => financialTransaction.credit > 0);
                } else {
                    this.financialTransactions = this.originalFinancialTransactions;
                }

            } else {
                this.financialTransactions = null;
            }
        },
        getFilteredItems(data) {

            const items = [];

            items.push({
                label: 'Update',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callUpdateActualFinancialTransaction(data);
                }
            });

            items.push({
                label: 'Delete',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callDeleteActualFinancialTransaction(data);
                }
            });

            items.push({
                label: 'Add Document',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callAddDocumentToFinancialTransaction(data);
                }
            });

            return items;
        },
        getFilteredItemsForStorage(data) {
            const items = [];

            items.push({
                label: 'Delete',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.callDeleteStorageRecord(data);
                }
            });

            items.push({
                label: 'View',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.viewFile(data);
                }
            });

            items.push({
                label: 'Download',
                class: 'mb-4 mr-4 ml-4 mt-4',
                command: () => {
                    this.downloadFile(data);
                }
            });

            return items;
        },
        chooseBlankSelection() {
            this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please select a valid option.',
                life: 3000
            });
        },
        formatAmount(value) {
            if (value) {
                return numeral(String(value)).format('0,0.00');
            } else {
                return numeral(String(0)).format('0,0.00');
            }
        },
        async callDeleteStorageRecord(data) {
            this.financialTransactionDocument = data;
            this.activeTab = 14;
        },
        async callViewFinancialTransactions() {
            const startDateInput = new Date((this.summary.start));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

            const endDateInput = new Date((this.summary.end));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

            const [responseData] = await Promise.all([
                FinancialTransactionService.getFinancialTransactionsByCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.financialTransactions = responseData.data;

            this.financialTransactions = this.financialTransactions.filter(item => item.financialAccountType === 'E');
            this.originalFinancialTransactions = this.financialTransactions;

            this.activeTab = 2;

        },
        async callOverallFinancialTransactions() {
            this.summary.start = moment().startOf('year').format('YYYY-MM-DD');
            this.summary.end = moment().startOf('month').format('YYYY-MM-DD');

            const startDateInput = new Date((this.summary.start));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

            const endDateInput = new Date((this.summary.end));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

            const [responseDataTransactions] = await Promise.all([
                FinancialTransactionService.getFinancialTransactionsByCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.financialTransactions = responseDataTransactions.data;

            this.originalFinancialTransactions = this.financialTransactions;

            const [responseDataAccounts] = await Promise.all([
                FinancialAccountService.getCompanyFinancialAccounts(this.profile.companyId)
            ]);

            this.financialAccounts = responseDataAccounts.data;

            this.activeTab = 2;
        },
        async callSupportingDocuments() {
            this.summary.start = moment().startOf('year').format('YYYY-MM-DD');
            this.summary.end = moment().startOf('month').format('YYYY-MM-DD');

            const startDateInput = new Date((this.summary.start));
            const yearStart = startDateInput.getFullYear();
            const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
            const dayStart = String(startDateInput.getDate()).padStart(2, '0');
            const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

            const endDateInput = new Date((this.summary.end));
            const yearEnd = endDateInput.getFullYear();
            const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
            const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
            const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

            const [responseData] = await Promise.all([
                FinancialTransactionService.getFinancialTransactionDocumentsByCompany(this.profile.companyId, startDate, endDate)
            ]);

            this.financialTransactionDocuments = responseData.data;

            this.originalFinancialTransactionDocuments = this.financialTransactionDocuments;

            this.columnsDefault = [
                {field: 'processed', header: 'Processed', sortable: true},
                {field: 'financialAccountType', header: 'Type', sortable: true},
                {field: 'financialAccountCode', header: 'Code', sortable: true},
                {field: 'financialAccountName', header: 'Name', sortable: true},
                {field: 'status', header: 'Status', sortable: true},
                {field: 'description', header: 'Description', sortable: true},
                {field: 'debit', header: 'Debit', sortable: true},
                {field: 'credit', header: 'Credit', sortable: true},
                {field: 'storageFileName', header: 'Storage Filename', sortable: true}
            ];

            this.selectedColumns = this.columnsDefault;

            this.activeTab = 13;

        },
        callLoadDefaultAccounts() {
            this.confirmationResponse = 'N';
            this.activeTab = 11;
        },
        async searchBillingPlan(event) {
            const [responseData] = await Promise.all([
                BillingPlanService.searchBillingPlans(this.profile.companyId, event.query.toLowerCase())
            ]);

            this.filteredBillingPlans = responseData.data;
        },
        callAddProduct(data) {
            this.activeTab = 11;
            this.invoice = data;
            if (this.products && this.products.length > 0) {
                this.product = this.products[0];
            }

        },
        handleClientFileUpload(event) {
            const fileDocument = event.target.files[0];

            if (!fileDocument) {
                this.fileDocument = null;
                return;
            }

            const allowedTypes = [
                'application/pdf',
                'image/png',
                'image/jpeg'
            ];

            if (!allowedTypes.includes(fileDocument.type)) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Invalid file type',
                    detail: 'Only PDF, PNG, and JPG files are allowed.',
                    life: 3000
                });
                this.resetClientFileInput();
                return;
            }

            this.fileDocument = fileDocument;
        },
        async uploadClientFile() {
            this.submitted = true;

            if (!this.fileDocument) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'No file selected.',
                    life: 3000
                });
            }

            const formData = new FormData();
            formData.append('file', this.fileDocument);

            const originalName = this.fileDocument.name;
            const filenameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.')) || originalName;

            const storageRecord = {
                companyId: this.profile.companyId,
                clientId: null,
                noteId: null,
                taskId: null,
                financialTransactionId: this.financialTransaction.id,
                type: 'F',
                provider: 'H',
                filename: filenameWithoutExt,
                simpleFilename: filenameWithoutExt,
                contentType: this.fileDocument.type
            };

            formData.append('storageRecord', new Blob([JSON.stringify(storageRecord)], {type: 'application/json'}));

            try {
                await axios.post('/api/storage/hetzner/upload', formData, {
                    headers: {
                        'Authorization': 'Bearer ' + this.userStore.accessToken,
                        'Content-Type': 'multipart/form-data'
                    }
                });

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'File uploaded successfully',
                    life: 3000
                });

            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Upload Failed',
                    detail: 'File upload NOT successful',
                    life: 3000
                });
            }

            this.resetClientFileInput();
            this.submitted = false;

            this.callResetFinancialTransactions();
        },
        async deleteStorageRecord() {
            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                if (this.financialTransactionDocument.id) {

                    try {

                        await StorageService.deleteCompanyStorage(this.financialTransactionDocument.storageId);

                        this.summary.start = moment().startOf('year').format('YYYY-MM-DD');
                        this.summary.end = moment().startOf('month').format('YYYY-MM-DD');

                        const startDateInput = new Date((this.summary.start));
                        const yearStart = startDateInput.getFullYear();
                        const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
                        const dayStart = String(startDateInput.getDate()).padStart(2, '0');
                        const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

                        const endDateInput = new Date((this.summary.end));
                        const yearEnd = endDateInput.getFullYear();
                        const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
                        const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
                        const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

                        const [responseData] = await Promise.all([
                            FinancialTransactionService.getFinancialTransactionDocumentsByCompany(this.profile.companyId, startDate, endDate)
                        ]);

                        this.financialTransactionDocuments = responseData.data;

                        this.originalFinancialTransactionDocuments = this.financialTransactionDocuments;

                        this.columnsDefault = [
                            {field: 'financialAccountType', header: 'Type', sortable: true},
                            {field: 'financialAccountCode', header: 'Code', sortable: true},
                            {field: 'financialAccountName', header: 'Name', sortable: true},
                            {field: 'status', header: 'Status', sortable: true},
                            {field: 'description', header: 'Description', sortable: true},
                            {field: 'debit', header: 'Debit', sortable: true},
                            {field: 'credit', header: 'Credit', sortable: true},
                            {field: 'storageId', header: 'Storage #', sortable: true},
                            {field: 'storageFileName', header: 'Storage Filename', sortable: true}
                        ];

                        this.selectedColumns = this.columnsDefault;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted file',
                            life: 3000
                        });

                    } catch (error) {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete file. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.activeTab = 13;
            this.submitted = false;

        },
        async viewFile(data) {
            const [response] = await Promise.all([
                StorageService.downloadFile(this.profile.companyId, data.storageId)
            ]);

            const blob = new Blob(
                [response.data],
                {type: data.storageContentType}
            );

            const url = URL.createObjectURL(blob);
            window.open(url);
        },
        async downloadFile(data) {
            try {
                const [responseData] = await Promise.all([
                    StorageService.downloadFile(this.profile.companyId, data.storageId)
                ]);

                const originalFilename = data.storageFileName;
                const filename = originalFilename.includes("~")
                    ? originalFilename.split("~").pop()
                    : originalFilename;

                const url = window.URL.createObjectURL(new Blob([responseData.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                // Clean up
                window.URL.revokeObjectURL(url);
                document.body.removeChild(link);

                this.$toast.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Downloaded file',
                    life: 3000
                });

            } catch (error) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to download file. Please try again.',
                    life: 3000
                });
            }
        },
        resetClientFileInput() {
            this.fileDocument = null;
            this.$refs.fileInput.value = '';
        },
        async loadDefaultAccounts() {

            this.submitted = true;

            if (this.confirmationResponse.trim() === "Y") {

                try {
                    await FinancialAccountService.createDefaultFinancialAccounts(this.profile.companyId);

                    this.summary.start = moment().startOf('year').format('YYYY-MM-DD');
                    this.summary.end = moment().format('YYYY-MM-DD');

                    const startDateInput = new Date((this.summary.start));
                    const yearStart = startDateInput.getFullYear();
                    const monthStart = String(startDateInput.getMonth() + 1).padStart(2, '0');
                    const dayStart = String(startDateInput.getDate()).padStart(2, '0');
                    const startDate = `${yearStart}-${monthStart}-${dayStart} 00:00:00`;

                    const endDateInput = new Date((this.summary.end));
                    const yearEnd = endDateInput.getFullYear();
                    const monthEnd = String(endDateInput.getMonth() + 1).padStart(2, '0');
                    const dayEnd = String(endDateInput.getDate()).padStart(2, '0');
                    const endDate = `${yearEnd}-${monthEnd}-${dayEnd} 23:59:59`;

                    const [financialSummaryData, financialAccountSummaryData] = await Promise.all([
                        DashboardService.getFinancialSummaryForCompany(this.profile.companyId, this.summary.start, this.summary.end),
                        FinancialTransactionService.getFinancialAccountSummary(this.profile.companyId, startDate, endDate)

                    ]);

                    this.financialSummary = financialSummaryData.data;
                    this.financialAccountSummary = financialAccountSummaryData.data;
                    // this.financialSummary.expenses = 39273.34;

                    const totalExpenses = this.financialAccountSummary
                        .filter(account => account.financialAccountType === 'E')
                        .reduce((sum, account) => sum + account.amount, 0);

                    this.financialSummary.expenses = totalExpenses;
                    this.financialSummary.profit = this.financialSummary.invoiceSummary - this.financialSummary.expenses;

                    this.financialAccountSummary = this.financialAccountSummary.filter(item => item.financialAccountType === 'E');

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Loaded Default Financial Accounts',
                        life: 3000
                    });

                } catch (error) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to load default financial accounts. Please try again.',
                        life: 3000
                    });
                }

            }

            this.activeTab = 1;
            this.submitted = false;

        },
        async emailInvoice() {
            this.submitted = true;
            this.loadingResponse = true;

            if (this.invoice.id) {

                if (this.confirmationResponse.trim() === "Y") {
                    try {
                        await InvoiceService.emailInvoice(this.invoice.id);

                        const [responseData] = await Promise.all([
                            InvoiceService.getAllCompanyInvoices(this.profile.companyId)
                        ]);

                        this.invoices = responseData.data;
                        this.originalInvoices = responseData.data;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Emailed invoice',
                            life: 3000
                        });
                    } catch (error) {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to email invoice. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.invoice = {};
            this.activeTab = 1;
            this.submitted = false;
            this.loadingResponse = false;
        },
        async deleteInvoice() {
            this.submitted = true;
            this.loadingResponse = true;

            if (this.invoice.id) {

                if (this.confirmationResponse.trim() === "Y") {
                    try {
                        await InvoiceService.deleteInvoice(this.invoice.id);

                        const [responseData] = await Promise.all([
                            InvoiceService.getAllCompanyInvoices(this.profile.companyId)
                        ]);

                        this.invoices = responseData.data;
                        this.originalInvoices = responseData.data;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Deleted invoice',
                            life: 3000
                        });
                    } catch (error) {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to delete invoice. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.invoice = {};
            this.activeTab = 1;
            this.submitted = false;
            this.loadingResponse = false;
        },
        async createClaim() {
            this.submitted = true;
            this.loadingResponse = true;

            if (this.invoice.id) {

                if (this.confirmationResponse.trim() === "Y") {
                    try {
                        await ClaimService.createClaim(this.invoice.id, this.healthInsuranceSubmissionMethodResponse.trim());

                        const [responseData] = await Promise.all([
                            InvoiceService.getAllCompanyInvoices(this.profile.companyId)
                        ]);

                        this.invoices = responseData.data;
                        this.originalInvoices = responseData.data;

                        this.$toast.add({
                            severity: 'success',
                            summary: 'Successful',
                            detail: 'Created claim for invoice',
                            life: 3000
                        });
                    } catch (error) {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to create claim for invoice. Please try again.',
                            life: 3000
                        });
                    }
                }
            }

            this.invoice = {};
            this.activeTab = 1;
            this.submitted = false;
            this.loadingResponse = false;
        },
        async addProduct() {
            this.submitted = true;
            this.loadingResponse = true;

            if (this.invoice.id) {

                try {
                    var tempProduct = "";

                    try {
                        tempProduct = this.product.id;
                    } catch (error) {
                        tempProduct = "";
                    }

                    await InvoiceService.addProductToInvoice(this.invoice.id, tempProduct);

                    const [responseData] = await Promise.all([
                        InvoiceService.getAllCompanyInvoices(this.profile.companyId)
                    ]);

                    this.invoices = responseData.data;
                    this.originalInvoices = responseData.data;

                    this.$toast.add({
                        severity: 'success',
                        summary: 'Successful',
                        detail: 'Added product to invoice',
                        life: 3000
                    });
                } catch (error) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to add product to invoice. Please try again.',
                        life: 3000
                    });
                }
            }

            this.invoice = {};
            this.activeTab = 1;
            this.submitted = false;
            this.loadingResponse = false;
        },
    }

}
;
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
}

::v-deep(.p-datatable-frozen-tbody) {
    font-weight: bold;
}

::v-deep(.p-datatable-scrollable .p-frozen-column) {
    font-weight: bold;
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

.status-badge, .type-badge {
    border-radius: var(--border-radius);
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}

.status-badge {
    &.status-A {
        background: #9da5d9;
        color: #080c61;
    }

    &.status-I {
        background: #B3E5FC;
        color: #23547B;
    }

}

.type-badge {
    &.status-FA {
        background: #C8E6C9;
        color: #256029;
    }

    &.status-CA {
        background: #FFCDD2;
        color: #C63737;
    }

    &.status-I {
        background: #FEEDAF;
        color: #8A5340;
    }

    &.status-E {
        background: #B3E5FC;
        color: #23547B;
    }

    &.status-CL {
        background: #ECCFFF;
        color: #694382;
    }

    &.status-LL {
        background: #d9b78a;
        color: #b94f03;
    }

    &.status-OE {
        background: #b9a1de;
        color: #830293;
    }

    &.status-Y {
        background: #C8E6C9;
        color: #256029;
    }

}

</style>

